import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FcRoleDropdownComponent } from './fc-role-dropdown.component';

const components = [FcRoleDropdownComponent];
@NgModule({
    imports: [CommonModule],
    declarations: components,
    exports: components
})
export class FcRoleDropdownModule {}
